<template>
  <div id="app">
    <div class="container my-16">
      <div class="font-medium text-3xl text-primary text-center mb-6">
        โปรแกรมคำนวณสินเชื่อบ้านเบื้องต้น
      </div>
      <CalculateLoan
        class="mb-16"
        @calculate="calculate($event)" />
      <InstallmentResult
        v-if="isSubmit"
        id="result"
        :amount-loan="amountLoan"
        :installment="installment"
        :revenue="revenue" />
    </div>
  </div>
</template>

<script>
import CalculateLoan from '@/components/CalculateLoan.vue'
import InstallmentResult from '@/components/InstallmentResult.vue'

export default {
  components: {
    CalculateLoan,
    InstallmentResult
  },
  data () {
    return {
      installment: null,
      revenue: null,
      amountLoan: null,
      isSubmit: false
    }
  },
  methods: {
    calculate (event) {
      this.installment = event.installment
      this.revenue = event.revenue
      this.amountLoan = event.amountLoan
      this.isSubmit = true
      setTimeout(() => {
        document.getElementById('result').scrollIntoView({ behavior: 'smooth' })
      }, 250)
    }
  }
}
</script>

<style lang="postcss" scoped>

</style>
